import React from 'react';

import * as copyrightStyles from './copyright.module.css';

export const Copyright = () => (
  <section className={copyrightStyles.copyright}>
    <p>©{new Date().getFullYear()} Bridge & Associates Appraisals Ltd.</p>
  </section>
);
